if (!customElements.get('mixtape-customizer')) {
    class MixtapeCustomizer extends HTMLElement {
        constructor() {
            super();
            const that = this;
            this.mixtapeSelection = document.querySelector('.mixtape-wrapper');
            this.submitButton = document.querySelector('.product-form__submit');
            this.variantAccordion = document.querySelector('product-variant-selects accordion-default');

            this.selections = new Proxy({
                charm1: false,
                charm2: false,
                charm3: false,
                chain: false,
                size: false,
            }, {
                set(target, property, value) {
                    target[property] = value;

                    if (Object.values(target).every(v => v === true)) {
                        that.onAllSelected();
                    }
                    
                    return true;
                }
            });
            this.init();
        }

        init() {
            this.querySelectorAll('.charms-list .charm:not(.popup-opener)').forEach(charm => {
                charm.addEventListener(
                    'click', () => {
                        this.onCharmClick(charm)
                    }
                );
            });
            document.querySelectorAll('.modal-letters .charm').forEach(charm => {
                charm.addEventListener(
                    'click', () => {
                        this.onModalCharmClick(charm)
                    }
                );
            });
            this.querySelectorAll('.chains-list .chain').forEach(chain => {
                chain.addEventListener(
                    'click', () => {
                        this.onChainClick(chain)
                    }
                );
            });
            this.mixtapeSelection.querySelectorAll('.charms .charm').forEach(placeholder => {
                placeholder.addEventListener(
                    'click', () => {
                        this.onPlaceholderClick(placeholder)
                    }
                );
            });
            document.querySelectorAll('[name^="Choose your chain length"]').forEach(sizeInput => {
                sizeInput.addEventListener(
                    'click', () => {
                        this.onSizeInputClick()
                    }
                );
            });

            this.variantAccordion.addEventListener(
                'click', () => {
                    // this.querySelector('.accordion__section.is-active summary').click()
                }
            )
        }

        onModalCharmClick(charm) {
            const modalDialog = charm.closest('modal-dialog')
            this.charmUpdate(charm, modalDialog)
            const parent = document.querySelector(`[data-modal="#${modalDialog.id}"]`)
                .closest('details') ;
            parent.querySelector('.selected')?.classList.remove('selected');
            document.querySelector(`[data-modal="#${modalDialog.id}"]`).closest('.charm').classList.add('selected')
            modalDialog.querySelector('[id^="ModalClose-"]').click()
        }

        onCharmClick(charm) {
            const accordion = charm.closest('details')
            this.charmUpdate(charm, accordion)
        }

        onPlaceholderClick(placeholder) {
            const index = placeholder.dataset.charmIndex;
            if (index) {
                this.querySelector(`[data-charm-index="${index}"]:not(.is-active) summary`).click()
            } else {
                this.querySelector('[data-chain-selection]:not(.is-active) summary').click()
            }
        }
        
        charmUpdate(charm, parent) {
            const charmIndex = parent.dataset.charmIndex;
            const charmImage = charm.querySelector('img');
            const charmSelected = this.mixtapeSelection.querySelector(`[data-charm-index="${charmIndex}"]`);
            const charmSelectedImg = charmSelected.querySelector('img');

            parent.querySelector('.selected')?.classList.remove('selected');
            charm.classList.add('selected');
            if (charmSelectedImg) {
                charmSelectedImg.src = charmImage.src
            } else {
                const charmToAdd = charmImage.cloneNode(true);
                charmSelected.prepend(charmToAdd);
            }
            document.querySelector(`#charm-${charmIndex}`).value = charmImage.alt;
            this.selections[`charm${charmIndex}`] = true;
        }
        
        onChainClick(chain) {
            const accordion = chain.closest('details')
            const chainImage = chain.querySelector('img');
            const chainSelectedImg = this.mixtapeSelection.querySelector(':scope > img');

            accordion.querySelector('.selected')?.classList.remove('selected');
            chain.classList.add('selected');
            this.mixtapeSelection.querySelector('.chain').classList.add('selected')

            const baseUrl = chainImage.dataset.image;

            chainSelectedImg.src = baseUrl;

            const widths = [360, 480, 600, 720, 840, 960];
            chainSelectedImg.srcset = widths
                .map(width => `${baseUrl.replace(/width=\d+/, `width=${width}`)} ${width}w`)
                .join(', ');
            document.querySelector(`#chain`).value = chainImage.alt;
            this.selections[`chain`] = true;
        }

        onSizeInputClick() {
            this.selections[`size`] = true;
        }

        onAllSelected() {
            if (this.submitButton) {
                this.submitButton.removeAttribute('disabled');
            }
        }
    }

    customElements.define('mixtape-customizer', MixtapeCustomizer);
}
